module.exports = __webpack_public_path__ + "media/images/logo-dark-5f097566656e459d8439c00e907b5916.png";